import React, {useEffect, useRef} from 'react'
import {HStack, Button, Text} from '@chakra-ui/react'
import {useIntl} from 'react-intl'
import {GiftBoxIcon} from '../icons'
import {trackAddToBabylistClick} from '../../tracking/analytics'
import {useAddGiftToBabylist} from '../../babylist-api'
import PropTypes from 'prop-types'

const AddToBabylist = ({product}) => {
    const {formatMessage} = useIntl()
    const {enabled, execute, loading, error} = useAddGiftToBabylist(product)
    const babylistBtnRef = useRef(null)
    const observerRef = useRef(null)

    useEffect(() => {
        if (!observerRef.current && enabled) {
            observerRef.current = new MutationObserver((mutations) => {
                mutations.forEach((m) => {
                    m.addedNodes.forEach((node) => {
                        if (node.tagName === 'IFRAME' && node.src.includes('babylist.com')) {
                            node.style.opacity = '0'
                            node.style.transition = 'opacity 180ms ease'

                            node.addEventListener(
                                'load',
                                () => {
                                    requestAnimationFrame(() => {
                                        node.style.opacity = '1'
                                    })
                                },
                                {once: true}
                            )
                            babylistBtnRef.current?.blur()
                            node.setAttribute('tabindex', '-1')
                            node.focus()
                        }
                    })

                    m.removedNodes.forEach((node) => {
                        if (node.tagName === 'IFRAME' && node.src.includes('babylist.com')) {
                            babylistBtnRef.current?.focus()
                            observerRef.current.disconnect()
                        }
                    })
                })
            })
        }

        return () => {
            if (observerRef.current) {
                observerRef.current.disconnect()
            }
        }
    }, [enabled])

    useEffect(() => {
        if (error) {
            observerRef.current.disconnect()
        }
    }, [error])

    if (!enabled) {
        return null
    }

    const handleAddToBabylist = () => {
        observerRef.current.observe(document.body, {childList: true, subtree: true})
        execute()
        trackAddToBabylistClick(product)
    }

    return (
        <HStack w="100%" justify={'center'} pb={2}>
            <Button
                variant="babyList"
                onClick={handleAddToBabylist}
                ref={babylistBtnRef}
                isDisabled={loading}
            >
                <HStack spacing={2} align="center">
                    <Text>
                        {formatMessage({
                            id: 'product_detail.link.add_to_babylist',
                            defaultMessage: 'Add to Babylist'
                        })}
                    </Text>
                    <GiftBoxIcon boxSize={4} />
                </HStack>
            </Button>
        </HStack>
    )
}

AddToBabylist.propTypes = {
    product: PropTypes.object
}

export default AddToBabylist
